import { render, staticRenderFns } from "./DraggableListTwoColumns.vue?vue&type=template&id=06e8b2ff&scoped=true"
import script from "./DraggableListTwoColumns.vue?vue&type=script&lang=js"
export * from "./DraggableListTwoColumns.vue?vue&type=script&lang=js"
import style0 from "./DraggableListTwoColumns.vue?vue&type=style&index=0&id=06e8b2ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e8b2ff",
  null
  
)

export default component.exports